import * as React from 'react'

import { TagColor as Color, Tag } from '@factorialco/deprecated-design-system'
import { PerformanceAgreementStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { useNewPerformanceModuleContext } from 'modules/performance_process/pages/ReviewsRootPage'

interface Props {
  status: PerformanceAgreementStatusEnum | 'not_initiated'
}

export const AgreementStatusTag: React.FC<Props> = ({ status }: Props) => {
  const { isAgreementDocumentEnabled } = useNewPerformanceModuleContext()

  switch (status) {
    case 'pending':
      return (
        <Tag inline capitalize type={Color.malibu}>
          {isAgreementDocumentEnabled
            ? i18n.t('performance_process.agreements.my_agreements.category_pending_confirmation')
            : i18n.t('performance_process.agreements.my_agreements.category_pending_signature')}
        </Tag>
      )
    case 'signed':
      return (
        <Tag inline capitalize type={Color.correct}>
          {isAgreementDocumentEnabled
            ? i18n.t('performance_process.agreements.status.confirmed')
            : i18n.t('performance_process.agreements.status.signed')}
        </Tag>
      )
    case 'not_initiated':
      return (
        <Tag inline capitalize type={Color.grey}>
          {i18n.t('performance_process.agreements.my_agreements.category_not_started')}
        </Tag>
      )
    default:
      const _exhaustiveCheck: never = status
      throw new Error(`Unhandled agreement status: ${_exhaustiveCheck}`)
  }
}
